import { CreateDemoForm } from "@/components/demos/CreateDemoForm";

export const DemoSend = ({ target }) => {
  const [first, ...rest] = (target.name || "").trim().split(/\s+/);
  const prefill = { first_name: first || "", last_name: rest.join(" "), business_name: target.business || "", email: target.email || "", phone: target.phone || "", lead_id: target.lead_id || "", lead_source: "Dialer" };
  return <div data-testid="qs-demo"><CreateDemoForm key={`${target.email}|${target.business}|${target.lead_id}|${target.name}`} prefill={prefill} compact /></div>;
};
